/* eslint-disable */
// @ts-nocheck

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { BasicType } from '../../interfaces/InterfacesLocal'
import { BasicNomenclator } from '../../interfaces/ServerInterfaces'
import { limpiarObjeto } from '../../utils/helpers'
import AsyncComboBox from '../forms/AsyncCombobox'
import ComboBox from '../forms/Combobox'
import DateInput from '../forms/DateInput'
import Input from '../forms/Input'
import MultiSelect from '../forms/Multiselect'
import Select from '../forms/Select'
import Toggle from '../forms/Toggle'
import Button from '../misc/Button'
import { FilterOpts, TableContext } from '../misc/GenericTable'
import MultipleFilterBtn from '../misc/MultipleFilterBtn'

interface FilterComponentInt {
  availableFilters: FilterOpts[]
  filterAction: Function
}

interface FilterComponentInterface {
  filterComponent: FilterComponentInt | undefined
  filterActived: boolean
  setFilterActived: React.Dispatch<React.SetStateAction<boolean>>
  closeModal: Function
}

const FilterComponent = ({
  filterComponent,
  filterActived,
  setFilterActived,
  closeModal,
}: FilterComponentInterface) => {
  const { selectedFilter, setSelectedFilter } = useContext(TableContext)

  const { handleSubmit, control, unregister, watch, reset } = useForm()
  const activeIndex = selectedFilter?.map((item) => item.id)
  const [selectedFilters, setSelectedFilters] = useState<BasicNomenclator[]>([])

  useEffect(() => {
    console.log(selectedFilter!)
    setSelectedFilters(
      selectedFilter!.map((item) => ({
        id: item.id.toString(),
        name: item.id.toString(),
      })) ?? []
    )
    const disabledFiltersCode = filterComponent?.availableFilters
      .filter((_, idx) => !activeIndex?.includes(idx))
      .map((item) => item.filterCode)
    if (selectedFilter?.length === 0 && filterActived) {
      filterComponent?.filterAction(null)
      setFilterActived(false)
    }
    unregister(disabledFiltersCode)
  }, [selectedFilter])

  const resetForm = () => {
    setSelectedFilter!([])

    filterComponent?.filterAction(null)

    closeModal()
  }

  const onSubmit: SubmitHandler<BasicType> = (data) => {
    const dataToSend = limpiarObjeto(data)

    const findFilterItem = (filterCode: string) => {
      return filterComponent?.availableFilters?.find((item) => {
        if (item.format === 'datepicker-range') {
          return item?.datepickerRange?.some(
            (newItem) => newItem?.filterCode === filterCode
          )
        }
        if (item.format === 'price-range') {
          return item?.priceRange?.some(
            (price) => price?.filterCode === filterCode
          )
        }
        return item.filterCode === filterCode
      })
    }

    const newSelectedFilter = Object.entries(dataToSend).map(([id, name]) => {
      const filterItem = findFilterItem(id)
      return {
        id,
        name,
        description: filterItem?.format ?? '',
        value: dataToSend[filterItem?.filterCode!],
      }
    })
    filterComponent?.filterAction(dataToSend)
    setSelectedFilter!(newSelectedFilter)
    closeModal()
    setFilterActived(true)
  }
  return (
    <form
      className="flex w-full flex-col gap-5"
      onSubmit={handleSubmit(onSubmit)}
    >
      {/**ACTIONS BUTTONS */}
      <div className="flex w-full items-center justify-center">
        <MultipleFilterBtn
          btnName="Criterios de búsqueda"
          data={
            filterComponent?.availableFilters.map((item) => ({
              id: item.filterCode,
              name: item.name,
            })) ?? []
          }
          onClear={() => {
            if (selectedFilters.length > 0) {
              reset()
              setSelectedFilters(() => [])
            }
          }}
          selected={selectedFilters}
          setSelected={(data: BasicNomenclator[], unregistered?: string) => {
            setSelectedFilters(data)
            unregistered && unregister(unregistered)
          }}
        />
      </div>

      {/**FILTERS BODY */}
      <div className="flex flex-1 flex-col gap-3 px-1">
        {filterComponent?.availableFilters
          ?.filter((item) =>
            selectedFilters.some((s) => s.id === item.filterCode)
          )
          .map((item, idx) =>
            item.format === 'select' && item.asyncData ? (
              <AsyncComboBox
                control={control}
                dataQuery={{
                  url: item.asyncData.url,
                  defaultParams: item.asyncData?.defaultParams,
                }}
                key={idx}
                label={item.name}
                name={item.filterCode}
                normalizeData={{
                  id: item.asyncData.idCode,
                  name: item.asyncData.dataCode,
                }}
                dependendValue={
                  item.dependentOn
                    ? { [item.dependentOn]: watch(item.dependentOn) }
                    : undefined
                }
                // defaultItem={selectedFilter?.find(elem => elem.id === item.filterCode)?.name ?? null}
              />
            ) : item.format === 'select' ? (
              <ComboBox
                control={control}
                data={item.data ?? []}
                key={idx}
                label={item.name}
                name={item.filterCode}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
                // rules={{ required: "Seleccione" }}
              />
            ) : item.format === 'multiselect' ? (
              <MultiSelect
                control={control}
                data={item.data ?? []}
                key={idx}
                name={item.filterCode}
                label={item.name}
                //@ts-ignore
                byDefault={
                  selectedFilter
                    ?.find((elem) => elem.id === item.filterCode)
                    ?.name.join(', ') ?? null
                }

                // rules={{ required: "Seleccione" }}
              />
            ) : item.format === 'input' ? (
              <Input
                control={control}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
                key={idx}
                label={item.name}
                name={item.filterCode}
              />
            ) : item.format === 'number' ? (
              <Input
                control={control}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
                key={idx}
                label={item.name}
                name={item.filterCode}
                type={'number'}
              />
            ) : item.format === 'boolean' ? (
              <Toggle
                control={control}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
                key={idx}
                name={item.filterCode}
                title={item.name}
              />
            ) : item.format === 'datepicker-range' ? (
              <div
                className="flex w-full flex-col items-start justify-start"
                key={idx}
              >
                <h2 className="mb-1 inline-flex items-center text-sm font-medium text-gray-700 first-letter:uppercase">
                  {item.name}
                </h2>
                <div
                  className="flex w-full items-center gap-1 font-normal"
                  key={idx}
                >
                  {item.datepickerRange?.map((rangeDatePicker, index) => {
                    return (
                      <div className={'w-full'}>
                        <DateInput
                          defaultValue={
                            selectedFilter?.find(
                              (elem) => elem.id === rangeDatePicker.filterCode
                            )?.name ?? null
                          }
                          fromCustom={
                            selectedFilter?.find(
                              (elem) => elem.id === item.filterCode
                            )?.name ?? null
                          }
                          includeTime={rangeDatePicker.includingTime}
                          key={index}
                          label={rangeDatePicker.name}
                          name={rangeDatePicker.filterCode}
                          widthFull={true}
                          control={control}
                          // rules={{ required: "Este campo es requerido" }}
                          untilToday={rangeDatePicker.isUnitlToday}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            ) : item.format === 'price-range' ? (
              <div
                className="flex w-full flex-col items-start justify-start"
                key={idx}
              >
                <h2 className="mb-1 inline-flex items-center text-sm font-medium text-gray-700 first-letter:uppercase">
                  {item.name}
                </h2>

                <div className="flex items-center gap-1 font-normal" key={idx}>
                  {item.priceRange?.map((priceRange, index) => {
                    return index !== 2 ? (
                      <Input
                        control={control}
                        key={index}
                        name={priceRange.filterCode}
                        type="number"
                        label={priceRange.name}
                        // rules={{ required: "Este campo es requerido" }}
                        textAsNumber
                      />
                    ) : (
                      <Select
                        control={control}
                        key={index}
                        label={priceRange.name}
                        name={priceRange.filterCode}
                        data={
                          priceRange?.currencies?.map((item) => ({
                            id: item,
                            name: item,
                          })) ?? []
                        }
                        // rules={{ required: "Este campo es requerido" }}
                      />
                    )
                  })}
                </div>
              </div>
            ) : (
              item.format === 'datepicker' && (
                <div className="flex items-center gap-1 font-normal" key={idx}>
                  <DateInput
                    control={control}
                    defaultValue={
                      selectedFilter?.find(
                        (elem) => elem.id === item.filterCode
                      )?.name ?? null
                    }
                    label={item.name}
                    fromCustom={
                      selectedFilter?.find(
                        (elem) => elem.id === item.filterCode
                      )?.name ?? null
                    }
                    // rules={{ required: "Este campo es requerido" }}
                    name={item.filterCode}
                    untilToday={item?.isUntilToday}
                  />
                </div>
              )
            )
          )}
      </div>
      <div className={'flex w-full justify-end gap-5'}>
        <Button
          action={resetForm}
          name="Limpiar"
          outline
          textColor="customBlue"
        />
        <Button name="Aplicar" type="submit" />
      </div>
    </form>
  )
}

export default FilterComponent
